import * as React from 'react';
import { useSelector } from 'react-redux';
import { trackHover } from './tracking';
import { Actual, TooltipContent } from '../../components/PriceRelevance';
import { getPriceRelevance } from '../../selectors/newbuilding';
import { EType } from '../../types/newbuilding/priceRelevance';

export const PriceRelevance = () => {
  const tooltip = useSelector(getPriceRelevance);

  if (!tooltip || tooltip.type === EType.Warning) {
    return null;
  }

  return (
    <Actual
      label={tooltip.label}
      title={tooltip.title}
      description={<TooltipContent description={tooltip.description} tracking={trackHover} />}
    />
  );
};

PriceRelevance.displayName = 'PriceRelevance';
